import PropTypes from "prop-types"
import styled, { css } from "styled-components"
import media from "@styles/media"
import { cssConfig } from "@utils/css-validator"

// Can make font size take "size" variable that runs it through the theme
// If we do that, should also take "fontSize" and override if exists
// TODO - Port this like how I've set up div, etc. Should inherit from paragraph

const Span = styled.span.withConfig(cssConfig)`
  color: ${props => props.color ?? props.theme.color.blue600};
  text-align: ${props => props.center && "center"};
  font-weight: ${props => props.fontWeight ?? "inherit"};
  font-size: ${props => props.fontSize ?? "inherit"};
  margin: ${props => props.margin ?? "0"};
  padding: ${props => props.padding ?? "0"};
  line-height: ${props => props.lineHeight ?? "inherit"};
  max-width: ${props => props.width};
  display: ${props => props.display};
  opacity: ${props => props.opacity};
  position: ${props => props.position};
  transition: ${props => props.transition};
  cursor: ${props => props.cursor};
  grid-area: ${props => props.area};
  white-space: ${props => props.whitespace};

  ${({ hideOnSm, hideOnMd }) =>
    (hideOnSm || hideOnMd) &&
    css`
      ${media.sm`
			  display: none;
		  `}
    `}

  ${({ hideOnMd }) =>
    hideOnMd &&
    css`
      ${media.md`
			  display: none;
		  `}
    `}
    
  ${({ hover }) =>
    hover &&
    css`
      :hover {
        color: ${({ hover }) => hover};
      }
    `}
`

Span.propTypes = {
  color: PropTypes.string,
  center: PropTypes.bool,
  fontWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fontSize: PropTypes.string,
  margin: PropTypes.string,
  padding: PropTypes.string,
  lineHeight: PropTypes.string,
  width: PropTypes.string,
  display: PropTypes.string,
  opacity: PropTypes.number,
  position: PropTypes.string,
  transition: PropTypes.string,
  cursor: PropTypes.string,
  area: PropTypes.string,
  whitespace: PropTypes.string,
  hideOnSm: PropTypes.bool,
  hideOnMd: PropTypes.bool,
}

export default Span
